import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { ISelectedEmailRecipient } from '..';
import { replaceTokenWithActualFirstNameString } from '../../../../models/UiUtils';
import { useAutomationTemplateQuery } from '../../../../queries/Automation';
import { AutomationPreviewStep } from '../../../../web/components/automation/AutomationPreview/presentation';
import { styleSheet } from '../styles';

export interface IProps {
	selectedRecipient: ISelectedEmailRecipient;
	templateId: string;
}

export const ChildAutomationViewer: React.FC<IProps> = ({ selectedRecipient, templateId }) => {
	const { data: automationTemplate, isLoading } = useAutomationTemplateQuery({
		id: templateId,
		enabled: !!templateId,
	});

	if (isLoading || !automationTemplate) {
		return null;
	}

	return automationTemplate?.published?.steps?.map((step: Api.IAutomationStep) => {
		const modifiedStep = { ...step };
		if (modifiedStep?.content) {
			modifiedStep.content = replaceTokenWithActualFirstNameString(
				modifiedStep.content,
				selectedRecipient?.contact?.firstName
			);
		}
		return (
			<div className={css(styleSheet.automationPreviewContainer)} key={step.id}>
				<AutomationPreviewStep
					template={automationTemplate}
					showPublished={true}
					step={modifiedStep}
					steps={automationTemplate.published.steps}
				/>
			</div>
		);
	});
};
